import Vue from 'vue'
import App from './App.vue'
import router from './router'
import GoEasy from 'goeasy';

Vue.config.productionTip = false

Vue.prototype.globalData = {
    currentAgent: null
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

const goEasy = GoEasy.getInstance({
	host: 'hangzhou.goeasy.io',	//应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
	appkey: 'BC-77e533197dc54faeaef6b103ddd7f7b2', // common key,
	modules: ['im']
});

Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;

